import createActionType from "../utils/createActionType";

export const MODULE = "add-product-to-kit-inline";

export const SET_IS_FETCHING_STATUS = createActionType(MODULE, "setIsFetchingStatus");
export const SET_PRODUCTS = createActionType(MODULE, "setProducts");
export const SET_IS_SEARCH_RESULT_OPEN = createActionType(MODULE, "setIsSearchResultOpen");
export const SET_SEARCH = createActionType(MODULE, "setSearch");
export const RESET = createActionType(MODULE, "reset");
export const INIT_INSTANCE = createActionType(MODULE, "initInstance");
export const REMOVE_INSTANCE = createActionType(MODULE, "removeInstance");
export const CLOSE_ALL_SEARCH_RESULTS = createActionType(MODULE, "closeAllSearchResults");
